import { Input } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../../../app/store";
import CopyIcon from "../../../../../../assets/icons/CopyIcon";
import { useUpdateRaisedTicketMutation } from "../../../../../../features/superAdmin/ticketService/ticketServiceApi";
import useCopy from "../../../../../../hooks/useCopy";
import useError from "../../../../../../hooks/useError";
import { toast } from "../../../../../../lib/toast";
import { capitalize, removeUnderscore } from "../../../../../../utils/string";

export const STATUS_CONFIG = {
  active: "status status-success",
  raised: "status status-success",

  opened: "status status-teal",
  re_opened: "status status-teal",
  in_progress: "status status-success",

  checked: "status status-warning",
  approved: "status status-primary",
  rejected: "status status-danger",
  executed: "status status-info",
  forwarded: "status status-dark",
  resolved: "status bg-[#FBEDFD] text-[#CF14EB]",

  canceled: "status status-danger",
  closed: "status status-danger",
};

interface TicketProps {
  ticket?: any;
}

export default function TicketDetailsTitleDesc({ ticket }: TicketProps) {
  const path = useLocation();
  const handleCopy = useCopy();
  const user = useAppSelector((state) => state.auth.user);

  const [title, setTitle] = useState<string>();
  const [desc, setDesc] = useState<string>();

  const paths = path?.pathname?.split("/");
  const isEditablePage = paths?.includes("creator-details");
  const isSameUserDept = user?.department_id === ticket?.raised_by_dept_id;
  const canEdit = isEditablePage && isSameUserDept;

  const [updateTicket, { isSuccess, isError, error }] =
    useUpdateRaisedTicketMutation();

  const handleEdit = () => {
    if (ticket?.title !== title || desc !== ticket?.description) {
      updateTicket({
        data: {
          title,
          description: desc,
        },
        id: ticket?.id as number,
      });
    }
  };

  useEffect(() => {
    if (ticket) {
      setDesc(ticket?.description);
      setTitle(ticket?.title);
    }
  }, [ticket]);

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Ticket Updated Successfully.");
    }
  }, [isSuccess]);

  useError(isError, error, "Ticket Update Failed.");
  return (
    <div>
      <div className="flex justify-between items-start my-4">
        <Input.TextArea
          readOnly={!canEdit}
          onBlur={handleEdit}
          onChange={(e) => setTitle(e.currentTarget.value)}
          value={title}
          autoSize={{ minRows: 1, maxRows: 15 }}
          className="text-[30px] font-semibold !border-0 !outline-none !ring-0 hover:!outline-none !p-0"
        />
        <div className="flex gap-2 mt-3.5">
          <div
            className="cursor-pointer"
            onClick={() => handleCopy(ticket?.generated_ticket_log_id)}
          >
            <CopyIcon />
          </div>
          <span className="block text-nowrap">
            {ticket?.generated_ticket_log_id}
          </span>
        </div>
      </div>
      <div
        className={`mb-5 status ${
          STATUS_CONFIG?.[
            ticket?.workflow_status?.toLowerCase() as keyof typeof STATUS_CONFIG
          ]
        }`}
      >
        {capitalize(removeUnderscore(ticket?.workflow_status))}
      </div>
      <div className="mb-4 text-base">
        <label className="mb-2 block">Description</label>
        <Input.TextArea
          size="large"
          readOnly={!canEdit}
          onBlur={handleEdit}
          value={desc}
          onChange={(e) => setDesc(e.currentTarget.value)}
          autoSize={{ minRows: 2, maxRows: 15 }}
        />
      </div>
    </div>
  );
}
